import * as React from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';
import ColumnResizeHandler from './ColumnResizeHandler';
import { defaultClassPrefix, getUnhandledProps, isNullOrUndefined, prefix } from './utils';
import Cell from './Cell';
import TableContext from './TableContext';
const propTypeKeys = [
    'index',
    'sortColumn',
    'dataIndex',
    'sortType',
    'sortable',
    'resizable',
    'minWidth',
    'onColumnResizeStart',
    'onColumnResizeEnd',
    'onResize',
    'onColumnResizeMove',
    'onSortColumn',
    'flexGrow',
    'fixed',
    'children',
    'onMouseEnterHandler',
    'onMouseLeaveHandler',
];
class HeaderCell extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleColumnResizeStart = (columnWidth) => {
            const { left = 0, fixed, onColumnResizeStart, resizeLeft = 0 } = this.props;
            if (onColumnResizeStart) {
                onColumnResizeStart(columnWidth, left + resizeLeft, !!fixed);
            }
        };
        this.handleColumnResizeMove = (width, left = 0, fixed) => {
            const { onColumnResizeMove = noop, resizeLeft = 0 } = this.props;
            onColumnResizeMove(width, left + resizeLeft, fixed);
        };
        this.handleColumnResizeEnd = (columnWidth, cursorDelta) => {
            const { dataKey, index, onColumnResizeEnd, onResize } = this.props;
            this.setState({ columnWidth });
            if (onColumnResizeEnd) {
                onColumnResizeEnd(columnWidth, cursorDelta, dataKey, index);
            }
            if (onResize) {
                onResize(columnWidth, dataKey);
            }
        };
        this.handleClick = () => {
            const { sortable, onSortColumn, dataKey } = this.props;
            if (sortable && onSortColumn) {
                onSortColumn(dataKey);
            }
        };
        this.handleShowMouseArea = (columnWidth) => {
            const { onMouseEnterHandler = noop, fixed, left = 0, resizeLeft = 0 } = this.props;
            onMouseEnterHandler(columnWidth, left + resizeLeft, !!fixed);
        };
        // @ts-ignore
        this.addPrefix = (name) => prefix(this.props.classPrefix)(name);
        this.state = {
            width: props.width,
            flexGrow: props.flexGrow,
            columnWidth: isNullOrUndefined(props.flexGrow) ? props.width : 0,
        };
    }
    static get contextType() {
        return TableContext;
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.width !== prevState.width || nextProps.flexGrow !== prevState.flexGrow) {
            return {
                width: nextProps.width,
                flexGrow: nextProps.flexGrow,
                columnWidth: isNullOrUndefined(nextProps.flexGrow) ? nextProps.width : 0,
            };
        }
        return null;
    }
    renderResizeSpanner() {
        const { resizable, left = 0, onMouseLeaveHandler, fixed, headerHeight, minWidth, groupCount, children, style } = this.props;
        const { columnWidth = 0 } = this.state;
        if (!resizable) {
            return null;
        }
        let defaultColumnWidth = columnWidth;
        // 处理组合列第一列拖拽柄定位问题
        if (groupCount && groupCount > 1) {
            defaultColumnWidth = children ? children.props.children[0].props.width : undefined;
        }
        return (React.createElement(ColumnResizeHandler, { defaultColumnWidth: defaultColumnWidth, key: columnWidth, columnLeft: left, columnFixed: fixed, height: headerHeight ? headerHeight - 1 : undefined, minWidth: minWidth, style: { top: style ? style.top : 0 }, onColumnResizeMove: this.handleColumnResizeMove, onColumnResizeStart: () => this.handleColumnResizeStart(defaultColumnWidth), onColumnResizeEnd: this.handleColumnResizeEnd, onMouseEnterHandler: () => this.handleShowMouseArea(defaultColumnWidth), onMouseLeaveHandler: onMouseLeaveHandler }));
    }
    renderSortColumn() {
        const { sortable, sortColumn, sortType = '', dataKey, groupHeader } = this.props;
        if (sortable && !groupHeader) {
            const iconClasses = classNames(this.addPrefix('icon-sort icon'), {
                [this.addPrefix(`icon-sort-${sortType}`)]: sortColumn === dataKey,
            });
            return (React.createElement("span", { className: this.addPrefix('sort-wrapper') },
                React.createElement("i", { className: iconClasses })));
        }
        return null;
    }
    render() {
        const { className, width, dataKey, headerHeight, children, left, sortable, classPrefix, sortColumn, sortType, groupHeader, ...rest } = this.props;
        const classes = classNames(classPrefix, className, {
            [this.addPrefix('sortable')]: sortable,
        });
        const unhandledProps = getUnhandledProps(propTypeKeys, rest);
        let ariaSort;
        if (sortColumn === dataKey) {
            ariaSort = 'other';
            if (sortType === 'asc') {
                ariaSort = 'ascending';
            }
            else if (sortType === 'desc') {
                ariaSort = 'descending';
            }
        }
        return (React.createElement("div", { className: classes },
            React.createElement(Cell, Object.assign({ "aria-sort": ariaSort }, unhandledProps, { width: width, dataKey: dataKey, left: left, headerHeight: headerHeight, isHeaderCell: true, onClick: !groupHeader ? this.handleClick : null }),
                children,
                this.renderSortColumn()),
            this.renderResizeSpanner()));
    }
}
HeaderCell.defaultProps = {
    classPrefix: defaultClassPrefix('performance-table-cell-header'),
};
export default HeaderCell;
